const INTERCOM_EXCLUDED_PATHS = [
  '/formularze/marketing/oferta',
  '/formularze/marketing/oferta/dziekujemy',
]

type WindowWithDataLayer = Window & { dataLayer?: Record<string, unknown>[] }

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig().public
  const route = useRoute()

  const gtmId = config.GTM_ID
  const auth = config.GTM_AUTH
  const preview = config.GTM_PREVIEW

  if (!gtmId) return

  const win = window as WindowWithDataLayer
  win.dataLayer = win.dataLayer || []
  const dataLayer = win.dataLayer

  let currentShouldHide = INTERCOM_EXCLUDED_PATHS.includes(route.path)

  function applyIntercomVisibility() {
    const intercom = document.querySelector<HTMLElement>('.intercom-lightweight-app, #intercom-container')
    if (intercom) {
      intercom.style.display = currentShouldHide ? 'none' : ''
    }
  }

  function toggleIntercom(path: string) {
    currentShouldHide = INTERCOM_EXCLUDED_PATHS.includes(path)

    dataLayer.push({ disableIntercom: currentShouldHide })
      ; (window as Window & { intercomSettings?: Record<string, unknown> }).intercomSettings = {
        hide_default_launcher: currentShouldHide,
      }

    applyIntercomVisibility()
  }

  const observer = new MutationObserver(() => {
    applyIntercomVisibility()
  })
  observer.observe(document.body, { childList: true, subtree: true })

  toggleIntercom(route.path)

  watch(
    () => route.path,
    (newPath) => {
      toggleIntercom(newPath)
    },
  )

  const script = document.createElement('script')
  script.innerHTML = `
  (function(w,d,s,l,i){
    w[l]=w[l]||[];
    w[l].push({'gtm.start': new Date().getTime(), event:'gtm.js'});
    var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),
        dl=l!='dataLayer' ? '&l='+l : '';
    j.async=true;
    j.src='https://www.googletagmanager.com/gtm.js?id=' 
          + i 
          + dl 
          + '&gtm_auth=${auth}'
          + '&gtm_preview=${preview}'
          + '&gtm_cookies_win=x';
    f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','${gtmId}');
  `

  document.head.appendChild(script)
})
